import { defineMessages } from 'react-intl-next';

export default defineMessages({
	placeholder: {
		id: 'ai-mate.chat-input.placeholder',
		defaultMessage: 'Write a prompt to get started',
		description: 'Placeholder for the chat input',
	},
	// keep consistent with /conversation-assistant-chat-prompt-input/src/ui/chat-prompt-input/messages.ts -> defaultAssistiveLabel
	placeholderUpdated: {
		id: 'ai-mate.chat-input.placeholder.updated',
		defaultMessage: 'Write a prompt, @mentions someone, or use / for actions',
		description: 'Placeholder for the chat input',
	},
	placeholderShort: {
		id: 'ai-mate.chat-input.placeholder.short',
		defaultMessage: 'Write a prompt...',
		description:
			'Shortened placeholder for the chat input in chromeless/inline comment contexts where space is limited.',
	},
});
